module.exports = __webpack_public_path__ + "static/give-and-take-89fa7df59e050d2689298ca877f23ffc.jpg";